import { render, staticRenderFns } from "./WarrantMatrix.vue?vue&type=template&id=7623ce22&scoped=true&"
import script from "./WarrantMatrix.js?vue&type=script&lang=js&"
export * from "./WarrantMatrix.js?vue&type=script&lang=js&"
import style0 from "./WarrantMatrix.vue?vue&type=style&index=0&id=7623ce22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7623ce22",
  null
  
)

export default component.exports